const LOCATION_SELECTORS: readonly [string, string][] = [
  ['nav', 'navbar'],
  ['header', 'header'],
  ['footer', 'footer'],
  ['[data-location]', ''],
];

export function getLocation(el: HTMLElement): string {
  for (const [selector, name] of LOCATION_SELECTORS) {
    const ancestor = el.closest(selector);
    if (ancestor) {
      if (name) return name;
      return (ancestor as HTMLElement).dataset.location ?? 'unknown';
    }
  }
  return 'body';
}

export function getElementType(el: HTMLElement): string {
  const tag = el.tagName.toLowerCase();
  if (tag === 'a') return 'link';
  if (tag === 'button') return 'button';
  return tag;
}

export function getClickText(el: HTMLElement): string {
  const text = el.getAttribute('aria-label') || el.textContent?.trim() || '';
  return text.slice(0, 100);
}
